// extracted by mini-css-extract-plugin
module.exports = {"area":"style_area__3m_ag"};